import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { WarehouseEntity } from './warehouse.entity';

/**
 * One row per (company, warehouse), soft-deleted rows included: a removed link
 * is restored, never added a second time. PD-16750 added the unique index
 * `company_warehouse_company_warehouse_unique` on (fk_company__id,
 * fk_warehouse__id) in migration 1790967959195, which first removes the
 * duplicate copies. It is not declared here yet because database sync runs
 * before migrations, and sync creating it while copies still exist would fail.
 * Declare it here, under the same name, once every tenant has run that
 * migration.
 */
@Index('fk_company__id', ['fkCompanyId'], {})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Entity('company_warehouse')
export class CompanyWarehouseEntity extends BaseEntity {
	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('int', { name: 'fk_warehouse__id', unsigned: true })
	public fkWarehouseId!: number;

	@ManyToOne(() => CompanyEntity, (company) => company.companyWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;

	@ManyToOne(
		() => WarehouseEntity,
		(warehouse) => warehouse.companyWarehouses,
		{
			onDelete: 'RESTRICT',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public fkWarehouse!: WarehouseEntity;
}
